import { request_detail } from '@/commons/hpod';
import Vue from 'vue';
import Crud from './crud'
var crud = new Crud('safe-level', 'cấp độ an toàn');

const state = {
    ...crud.state,
    selected: {
        ID: 0
    },
    safe_level_by_store: []
};
const getters = {
    ...crud.getters,
};
const actions = {
    ...crud.actions,
    get_safe_level_by_store({ commit }, id) {
        commit("setLoading", { loading: true });
        request_detail('safe-level-by-store', ret => {
            commit('set_safe_level_by_store', ret.data);
            commit("setLoading", { loading: false });
        }, Vue.http, id, this.state.authentication.token);
    }
};
const mutations = {
    ...crud.mutations,
    set_safe_level_by_store(state, item) {
        state.safe_level_by_store = item.data ? item.data : item;;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};